import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { catchError, map } from 'rxjs/operators';
import { GLOBAL } from './global';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of } from "rxjs";

@Injectable()
export class PropiedadService {
    public url;

    constructor(private _http: HttpClient, private _http2: Http) {
        this.url = GLOBAL.url;
    }

    getPropiedad(rol?, id?, dir?, num?) {
        var params;

        if (rol && dir == undefined && num == undefined) {
            params = {
                rol: rol,
                id: id
            }
        }
        if (dir && num && rol == undefined) {
            params = {
                dir: dir,
                num: num
            }
        }
        console.log("getPropiedad() propiedad.service.ts", params)
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/propiedad', params, { headers: headers })
            .pipe(map((response: any) => response));
    }

    savePropiedad(rol) {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/propiedad', rol, { headers: headers })
            .pipe(map((response: any) => response));
    }


    traerCalles() {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        let params = {
            param: "param"
        }
        return this._http.post(this.url + 'traerCalles', params, { headers: headers })
            .pipe(map((response: any) => response));
    }

getCalles() {
  const token = sessionStorage.getItem("token-domCloud") || '';

  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': token } : {})
  });

  return this._http.get<{ calles: string[] }>(`${this.url}get/calles`, { headers })
    .pipe(
      map((response) => {
        if (response && Array.isArray(response.calles)) {
          return response;
        } else {
          console.warn('⚠️ Respuesta inesperada de getCalles:', response);
          return { calles: [] }; // Valor por defecto
        }
      }),
      // en caso de error HTTP (401, 500, etc.)
      catchError((err) => {
        console.error('❌ Error en getCalles()', err);
        return of({ calles: [] }); // evitar que rompa el componente
      })
    );
}

}